"use strict";

exports.__esModule = true;
exports.useMappingProps = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Translator = require("../../Core/Translator");
var _DeviceContext = require("../../Device/DeviceContext");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var useMappingProps = exports.useMappingProps = function useMappingProps() {
  var _useState = (0, _react.useState)(false),
    isDialogOpen = _useState[0],
    setIsDialogOpen = _useState[1];
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var device = _react["default"].useContext(_DeviceContext.DeviceContext);
  var toggleDialog = function toggleDialog() {
    setIsDialogOpen(!isDialogOpen);
  };
  var invoke = function invoke() {
    setIsDialogOpen(true);
  };
  var childProps = {
    invoke: invoke
  };
  return {
    isDialogOpen: isDialogOpen,
    childProps: childProps,
    translate: translate,
    device: device,
    toggleDialog: toggleDialog
  };
};